import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import AuthContext from '../../context/autenticacion/authContext';

const TopBar = () => {

    const authContext = useContext(AuthContext);
    const { usuario, accesos, cerrarSesion, usuarioAPIAutenticado } = authContext;

    const isPathActive = ( path ) => {
        return window.location.pathname.startsWith( path );
    }

    useEffect( () => {
        usuarioAPIAutenticado( 1 );

        //eslint-disable-next-line
    },[] );

    return ( 
        <nav className="navbar navbar-expand-lg navbar-dark" style={{backgroundColor:"#ee4d95"}}>
            <a className="navbar-brand"
                href="!#"
                onClick={evt => evt.preventDefault()}>Limed
            </a>
            <button className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div className="navbar-nav">
                    {
                        !accesos ?
                            null
                        :
                            accesos.map( ( a, index ) => (
                                <Link
                                    key={index}
                                    className={ isPathActive(`${a.link}`) ? 'nav-item nav-link active' : 'nav-item nav-link' }
                                    to={`${a.link}`}>{a.acceso}
                                </Link>
                            ) )
                    }
                    {/*<Link
                        className={ isPathActive('/resultados') ? 'nav-item nav-link active' : 'nav-item nav-link' }
                        to="/resultados">Resultados
                    </Link>
                    <Link
                        className={ isPathActive('/citas') ? 'nav-item nav-link active' : 'nav-item nav-link' }
                        to="/citas">Citas
                    </Link>*/}
                </div>
            </div>
            <ul className="navbar-nav navbar-nav-right ml-lg-auto">
                {
                    usuario ?
                        <li className="nav-item nav-profile border-0 mr-10">
                            <Dropdown alignRight>
                                <Dropdown.Toggle className="nav-link bg-transparent">
                                    <span className="profile-text font-weight-bold">{ usuario ? usuario.nombre : null }</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="preview-list navbar-dropdown pb-3">
                                    <Dropdown.Item
                                        className="dropdown-item preview-item d-flex align-items-center border-0"
                                        onClick={cerrarSesion}
                                    >
                                        Cerrar sesión
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </li>
                    :
                        null
                }
            </ul>
        </nav>
     );
}
 
export default TopBar;